module.exports = __webpack_public_path__ + "img/replay-button.36ebcc6f.png";